"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.generateDestinationUserUrl = generateDestinationUserUrl;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _globals = _interopRequireDefault(require("@insided/shared/utils/globals"));

var _toKebabCase = require("@insided/shared/utils/toKebabCase");

/**
 * Generates the appropriate user profile URL based on application context
 */
function generateUserUrl(user) {
  if ((0, _globals.default)('application') === 'control') {
    return "/member/profile?userid=".concat(user.id);
  }

  return "/members/".concat((user === null || user === void 0 ? void 0 : user.name).toLowerCase(), "-").concat(user.id);
}
/**
 * Generates destination-specific user profile URL with kebab-case formatting
 * Use this for destination-only components that need proper URL formatting
 */


function generateDestinationUserUrl(username, userId) {
  return "/members/".concat((0, _toKebabCase.textToKebab)(username), "-").concat(userId);
}
/**
 * Determines the final URL to use for the user avatar
 */


function getUserUrl(disableLink, user) {
  if (disableLink) return undefined;
  if (user.url) return user.url;
  return generateUserUrl(user);
}

var AvatarLink = function AvatarLink(_ref) {
  var user = _ref.user,
      disableLink = _ref.disableLink,
      openInNewTab = _ref.openInNewTab,
      children = _ref.children,
      className = _ref.className;
  var userUrl = getUserUrl(disableLink, user); // Guardian clause: If no URL (link disabled), render as span

  if (!userUrl) {
    return (0, _preact.h)("span", {
      className: className
    }, children);
  } // Default: Render as link


  return (0, _preact.h)("a", {
    className: className,
    href: (0, _absoluteUrlRuntime.resolveUrl)(userUrl),
    target: openInNewTab ? '_blank' : undefined,
    rel: "noreferrer"
  }, children);
};

var _default = AvatarLink;
exports.default = _default;